<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content is-wide">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add BOM Details</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <div class="modal-card-body">

          <div class="columns">
            <product-navigator 
              :key="value"
              class="column is-one-quarter"
              v-model="product"/>
          
            <bom-details-selector 
              class="column is-three-quarters"
              :product="product"
              @select="add"
              @deselect="remove"/>
          </div>

        </div>

        <footer class="modal-card-foot">
          <button 
            class="button is-primary" 
            @click.stop="saveBomDetails()">
            Add Selected {{ selected.length }} BOM Details
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import ProductNavigator from '@/components/inventory/ProductNavigator'
import BomDetailsSelector from '@/components/inventory/BomDetailsSelector'

import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    orderId: {
      type: [String, Number]
    }
  },
  components: { 
    BomDetailsSelector,
    ProductNavigator
  },
  data() {
    return {
      product: {
        product_master_id: null,
        stocking_unit_id: null
      },
      selected: [],
      products: []
    }
  },
  methods: {
    ...mapActions("order", ["addBomDetail"]),
    ...mapMutations("app", ["setNotification"]),
    add(bomDetail) {
      this.selected.push(bomDetail);
    },
    remove(bomDetailId) {
      this.selected.forEach((bomDetail, i) => {
        if (bomDetail.id == bomDetailId) {
          this.selected.splice(i, 1);
        }
      })
    },
    saveBomDetails() {
      let details = this.selected.map(d => {
        return {
          order_id: this.orderId,
          bom_detail_id: d.id
        }
      });

      details.forEach((detail, i) => {
        this.addBomDetail(detail).then(() => {
          if (i+1 == details.length) {
            this.notifySuccess();
          }
        })
      })
    },
    notifySuccess() {
      this.setNotification({
        status: true,
        type: 'success',
        message: 'Bom details successfully added to order'
      });
      
      this.close(true);
    },
    close() {
      this.$emit('input', false);
      // if (clear) {
      //   this.clearData();
      // }
    }
    // clearData() {
    //   Object.assign(this.$data, this.$options.data.call(this));
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/modal.scss';

.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>
